/**
 * @flow
 */

import { connect } from 'react-redux';
import { setDate } from '../../../actions/appointments';
import { DatePicker } from '../../../components';

const mapStateToProps = ({ appointments }) => ({
    value: appointments.get('date'),
    dayPickerProps: {
        defaultMonth: appointments.get('date'),
        selected: appointments.get('date'),
        mode: 'single',
    },
});

export default connect(mapStateToProps, { onChange: setDate })(DatePicker);
